import { CBadge } from "@coreui/react";
import React, { useEffect, useState } from "react";
import { apiCallSPPost } from "src/_apiConfig/apiCall";
import ToastMessage from "src/_components/ToastMessage";
import { AlertResponse } from "src/_constants/alert.type";
import Auth from "src/auth";
import CommonList from "src/views/common/CommonList";
import {
  CommonSearch,
  SCAddButton,
  SCSelect,
  updateSearchStatus,
} from "src/views/common/CommonSearch";
import TableDateFromat from "src/views/common/Table/TableDateFromat";
import { useParams } from "react-router-dom";
import { CommonBtnTo } from "src/views/common/Common";

const AdHocPaymentList = () => {
  const { authenticated } = Auth();
  const { type } = useParams();
  const [usersData, setUserData] = useState(); // List data manage
  const [pageCount, setPageCount] = useState(0); // List Data pagging manage
  const [loading, setloading] = useState(false); // page loading
  const [pageLimit, setpageLimit] = useState(0); // pageing index manage
  const [itemPerPage, setItemPerPage] = useState(10); // Record Show Each Page
  const [disabledprev, setdisabledprev] = useState(false); //Pagging Prev. Button disabled manage;
  const [disablednext, setdisablednext] = useState(false); //Pagging Next Button disabled manage;
  const [isSearch, setIsSearch] = useState(false); // Search Button Effect Manage
  const [isClear, setIsClear] = useState(false); // Clear Button Effect Manage
  // const [textField, settextField] = useState("tenderNo"); // table header Default Selected Column
  // const [order, setorder] = useState("asc"); // table header Default Selected Column order Set
  // const [orderClick, setOrderClick] = useState(true); // table header orderClick Column manage
  const [toasts, setToasts] = useState(AlertResponse);

  // Your default search model
  const status_id_type =
    type != null || type !== undefined
      ? type === "1"
        ? 1
        : type === "4"
        ? 4
        : ""
      : "";
  const SearchFilterModel = {
    tenderNo: "",
    lotNo: "",
    date: "",
    collectionSeason: new Date().getFullYear().toString(),
    status_id: status_id_type,
    payment_type_id: 0,
  };

  const [search, setSearch] = useState(SearchFilterModel); // Search Manage

  useEffect(() => {
    debugger;
    setloading(true);
    resetPageLimit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated]);

  useEffect(() => {
    debugger;
    if (isSearch === false) {
      getGoDownRentFeeExtensionList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, pageLimit, itemPerPage]);

  useEffect(() => {
    if (isSearch) {
      getGoDownRentFeeExtensionList();
      setIsClear(false);
      setIsSearch(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSearch, itemPerPage]);

  //Pagging Disabled /Enable manage
  const paggingDisabled = (isNext = true, isPrev = true) => {
    setdisablednext(isNext);
    setdisabledprev(isPrev);
  };
  //Pagging manage
  const paggingManage = (totalRecord, isRecordGet = true) => {
    setPageCount(parseInt(totalRecord) || 0);
    paggingDisabled(
      pageLimit >= parseInt(totalRecord) - parseInt(itemPerPage),
      pageLimit === 0
    );
  };

  // api data manage
  const getdata = (setPageLimits = "", setItemPerPages = "") => {
    return JSON.stringify({
          collection_season: Number(search.collectionSeason),
          length: setItemPerPages === "" ? itemPerPage : setItemPerPages,
          lot_no: search.lotNo.trim(),
           payment_type_id: Number(search.payment_type_id),
          start: setPageLimits === "" ? pageLimit : setPageLimits,
          status_id: Number(search.status_id),
          tenderNo: search.tenderNo.trim(),
        user_id: authenticated.userId,
        user_type:
        authenticated.role === "CGMF"
          ? 1
          : authenticated.role === "DFO"
          ? 2
          : 0,
    });
  };

  const getGoDownRentFeeExtensionList = async () => {
    if (authenticated) {
      setloading(true);
      paggingDisabled();
      setUserData();

      await apiCallSPPost("LotAdHocPayment/Checker/List", getdata(), [])
        .then((res) => {
          if (res.success) {
            setUserData(res.data);

            if (isSearch === false && pageLimit >= 0 && pageCount > 0) {
              paggingManage(pageCount);
            } else {
              paggingManage(parseInt(res.totalRecord) || 0);
            }
          } else {
            setUserData();
            paggingManage(0, false);
            alert(res.message);
          }
        })
        .finally(() => {
          setloading(false);
        });
    }
  };

  const resetPageLimit = (pageLimit) => {
    setpageLimit(pageLimit || 0);
  };

  // Pagging Prev. Button Click Event
  const prevButton = () => {
    let pageLimitSet = parseInt(pageLimit) - parseInt(itemPerPage);
    pageLimitSet = pageLimitSet < 0 ? 0 : pageLimitSet;
    resetPageLimit(pageLimitSet);
  };
  // Pagging Next Button Click Event
  const nextButton = () => {
    let pageLimitSet = parseInt(pageLimit) + parseInt(itemPerPage);
    pageLimitSet =
      pageLimitSet >= parseInt(pageCount) ? parseInt(pageCount) : pageLimitSet;
    resetPageLimit(pageLimitSet);
  };
  // Search Model Value Update Manage
  const updateSearch = (e, name = "", value = "") => {
    updateSearchStatus(setSearch, search, e, name, value);
  };
  // item per page  onChanage Event
  const onChangePage = (ev) => {
    ev.preventDefault();
    setpageLimit(0);
    setItemPerPage(ev.target.value);
    setIsSearch(true);
    paggingManage(pageCount);
  };

  // Search Button Click Event
  const searchButton = (ev) => {
    ev.preventDefault();
    resetPageLimit();
    setIsSearch(true);
  };

  //Clear Button Click Event
  const clearSearch = (ev) => {
    ev.preventDefault();
    resetPageLimit();
    setIsClear(true);
    setIsSearch(true);
    setSearch({ ...search, ...SearchFilterModel });
    setUserData([]);
  };

  const statusList = [
    { value: "1", label: "Pending" },
    { value: "2", label: "Approved" },
    { value: "3", label: "Rejected" },
    { value: "4", label: "Clarification" },
  ];

  const searchControl = (
    <>
      {/* <SCInput
        label={"Lot No :"}
        name={"lotNo"}
        value={search.lotNo}
        onChange={updateSearch}
      /> */}

      <SCSelect
        labelname="Approval Status"
        name="status_id"
        value={search.status_id}
        onChange={updateSearch}
        items={statusList}
      />
    </>
  );
  let additional = (
    <CommonSearch
      isDisabledSearchClear={loading}
      extraControl={searchControl}
      isClear={isClear}
      search={search}
      updateSearch={updateSearch}
      searchButton={searchButton}
      clearSearch={clearSearch}
      itemPerPage={itemPerPage}
      onChangePage={onChangePage}
      isLotNumberDisplay={true}
      extraSearchControl={
        authenticated.role === "DFO" && (
          <SCAddButton tourl={"/lot/adhocpayment/Add"} />
        )
      }
    />
  );
  const getStatusText = (status, isClarificationByLoginUser) => {

    switch (status) {
      case 1:
        return "Pending";
      case 2:
        return "Approved";
      case 3:
        return "Reject";
      case 4:
        return isClarificationByLoginUser === true ? (
          <CBadge color="info" className="mfs-auto badgeFont100">
            Clarification
          </CBadge>
        ) : (
          "Clarification"
        );
      default:
        return "";
    }
  };
  let scopedSlotsList = {
    paymentTypeValue: (item, index) => {
      //return item.paymentTypeId;
      return (
        <td className="py-2">
          <span>
            {item.paymentTypeId === 1
              ? "Payment Collected without GST"
              : item.paymentTypeId === 2
              ? "Payment Collected with GST"
              : item.paymentTypeId === 3
              ? "Only Collected GST"
              : ""}
          </span>
        </td>
      );
    },
    statusValue: (item, index) => {
      return (
        <td className="py-2">
          <span>
            {getStatusText(item.status, item.isClarificationByLoginUser)}
          </span>
        </td>
      );
    },
    inserteddateformat: (item, index) => {
      return TableDateFromat(item.insertedDateTime);
    },
    viewbtn: (item, index) => {
      let id = window.btoa(item.adHocPaymentId);

      return (
        <td className="py-2 ">
          <CommonBtnTo
            isDisplayAllow={true}
            to={"/lot/adhocpayment/view/" + id}
            ButtonName={"View"}
          />

          <CommonBtnTo
            className="mt-1"
            isDisplayAllow={
              item.isClarificationByLoginUser === true &&
              item.isClarificationToMaker === true
                ? true
                : false
            }
            to={"/lot/adhocpayment/edit/" + id}
            ButtonName={"Clarification"}
          />
        </td>
      );
    },
  };
  let fields = [
    // {
    //   key: "srNo",
    //   _style: { width: "5%" },
    //   label: "S.N.",
    // },
    {
      key: "tenderNo",
      _style: { width: "7.5%" },
      label: "Tender No",
    },
    {
      key: "lotNo",
      _style: { width: "7.5%" },
      label: "Lot No",
    },
    {
      key: "purchaserName",
      _style: { width: "10%" },
      label: "Purchaser",
    },

    {
      key: "totalAmount",
      _style: { width: "5%" },
      label: "Total Amount",
    },

    {
      key: "paymentTypeValue",
      _style: { width: "10%" },
      label: "Payment Type",
    },
    {
      key: "statusValue",
      _style: { width: "10%" },
      label: "Approval Status",
    },
    {
      key: "paymentStatus",
      _style: { width: "10%" },
      label: "Payment Status",
    },
    {
      key: "dueDate",
      _style: { width: "10%" },
      label: "Due Date",
    },
    {
      key: "insertedDateTime",
      _style: { width: "10%" },
      label: "Created Date",
    },
    {
      key: "insertByName",
      _style: { width: "15%" },
      label: "Created By",
    },
    {
      key: "checkerDate",
      _style: { width: "10%" },
      label: "Checker Date",
    },
    {
      key: "checkerByName",
      _style: { width: "25%" },
      label: "Checker By",
    },
    {
      key: "viewbtn",
      _style: { width: "5%" },
      label: "View",
    },
  ];

  return (
    <>
      <ToastMessage toasts={toasts} setToasts={setToasts} />
      <CommonList
        items={usersData}
        fields={fields}
        listName="Adjustment Payment"
        loading={loading}
        prev={prevButton}
        next={nextButton}
        disabledprev={disabledprev}
        disablednext={disablednext}
        additional={additional}
        // path={`/GoDownFeesExtension/Edit/`}
        // tabBtn="Edit"
        // id="id"
        scopedSlots={scopedSlotsList}
      />
    </>
  );
};

export default AdHocPaymentList;
